var _rect, _path, _path2, _rect2, _path3, _path4, _circle, _rect3, _rect4, _rect5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLockLockedCircleBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 158,
    height: 168,
    viewBox: "0 0 158 168",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    width: 157.5,
    height: 157.5,
    rx: 78.75,
    fill: "#29B8FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.5 60.375C110.5 42.978 96.397 28.875 79 28.875C61.603 28.875 47.5 42.978 47.5 60.375V110.25H110.5V60.375ZM60.6295 59.9647C60.8477 50.0059 68.9889 42 79 42L79.4103 42.0045C89.3691 42.2227 97.375 50.3639 97.375 60.375V97.125H60.625V60.375L60.6295 59.9647Z",
    fill: "#E8E8E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.801 110.25C103.891 109.387 103.938 108.512 103.938 107.625V60.375C103.938 46.6024 92.7726 35.4375 79 35.4375C65.2274 35.4375 54.0625 46.6024 54.0625 60.375V107.625C54.0625 108.512 54.1088 109.387 54.199 110.25H103.801ZM79 42C68.9889 42 60.8477 50.0059 60.6295 59.9647L60.625 60.375V97.125H97.375V60.375C97.375 50.3639 89.3691 42.2227 79.4103 42.0045L79 42Z",
    fill: "#9B9B9B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 84,
    width: 84,
    height: 84,
    rx: 2,
    fill: "#FFC220"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M113.125 84H119C120.105 84 121 84.8954 121 86V166C121 167.105 120.105 168 119 168H113.125V84Z",
    fill: "#E29700"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37 86C37 84.8954 37.8954 84 39 84H44.875V168H39C37.8954 168 37 167.105 37 166V86Z",
    fill: "#F8E6A5"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 79,
    cy: 115.5,
    r: 9.1875,
    fill: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 73.75,
    y: 112.875,
    width: 10.5,
    height: 28.875,
    rx: 4,
    fill: "black"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 55.375,
    y: 149.625,
    width: 47.25,
    height: 2.625,
    rx: 1.3125,
    fill: "#E29700"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 55.375,
    y: 156.188,
    width: 47.25,
    height: 2.625,
    rx: 1.3125,
    fill: "#E29700"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockLockedCircleBlue);
export default __webpack_public_path__ + "static/media/LockLocked_Circle_Blue.00074a07b22f7caa9bd09de8933c7437.svg";
export { ForwardRef as ReactComponent };